import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('selectPrimaryBoundaryField');

    return {
        PRIMARY_BOUNDARY: t('primaryBoundary'),
        PRIMARY_BOUNDARY_PLACEHOLDER: t('primaryBoundaryPlaceholder')
    };
};

export default useTranslation;
